var ezdia;
(function (ezdia) {
    function tabMarkup(colModel) {
        var e_1, _a;
        var name = colModel.name, config = colModel.config;
        var context = '';
        var checked = "checked=\"checked\"";
        try {
            for (var _b = __values(Object.entries(config.options)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], label = _d[1];
                context += "\n        <input href=\"#ez-js-tab-" + key + "\" type=\"radio\" name=\"" + name + "\" id=\"add_product_type_" + key + "\" value=\"" + key + "\" " + checked + ">\n        <label for=\"add_product_type_" + key + "\">" + label + "</label>\n      ";
                checked = '';
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return "<div class=\"nav-add-product-tabs\" id=\"ez-js-nav-add-product-tabs\">\n      " + context + "\n    </div>";
    }
    function formFields(column) {
        var markup = $.ezdia.inputs.getMarkup({
            column: column
        });
        return column.edittype === 'hidden' ? markup : markup.prop('outerHTML');
    }
    function tabContent(colModelArray) {
        var e_2, _a;
        var colModel = __spread(colModelArray);
        var config = colModel[0].config;
        var active = 'active';
        var count = 0;
        var markup = '';
        colModel.shift();
        try {
            for (var _b = __values(Object.entries(config.options)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 1), key = _d[0];
                markup += "\n        <div class=\"tab-pane " + active + "\" id=\"ez-js-tab-" + key + "\">\n          " + formFields(colModel[count]) + "\n        </div>\n      ";
                active = '';
                count += 1;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return markup;
    }
    function formContent(colModel) {
        return "<div class=\"ez-add-product-wrapper ez-qq-list-view\">\n      <form id=\"ez-js-add-product-form\">\n        " + tabMarkup(colModel[0]) + "\n        <div class=\"tab-content\">\n          " + tabContent(colModel) + "\n        </div>\n      </form>\n    </div>";
    }
    function optimizationFormContent(colModel) {
        var fields = colModel
            .map(function (col) {
            return formFields(col);
        })
            .join('');
        return "<div class=\"ez-prod-optimization-wrapper\">\n      <form id=\"ez-js-prod-optimization-form\" class=\"form-horizontal ezdia-form desk\">\n        " + fields + "\n      </form>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.contentHealthAnalysis = {
            formContent: formContent,
            optimizationFormContent: optimizationFormContent
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
